import React, { useEffect, useState } from "react";

import VectorStar from "../../../assets/vectorStar.svg";
import Group from "../../../assets/Group.png";
import Sp from "../../../assets/distrSpotify.png";
import Drawer from "@material-ui/core/Drawer";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContractForm from "./ContractForm";

import {
  useTable,
  useSortBy,
  useFilters,
  useGlobalFilter,
  usePagination,
} from "react-table";

import { GlobalFilter } from "../../admin/ReleasesAdmin";

import TableView from "../../../screens/Admin/Releases/components/TableView";
import { Link, useHistory } from "react-router-dom";
import { deleteContract, getContracts } from "../../../services/contracts";
import { useQuery } from "react-query";
import TrashIcon from "../../../assets/icons/trash.svg";
import Toast from "../../Toast";
import { useSelector } from "react-redux";
import ContractStatusFilter from "./ContractStatusFilter";

const INITIAL_PAGE_SIZE = 10;

const statusCssClasses = {
  closed: "danger",
  expired: "danger",
  active: "success",
  scheduled: "warning",
};

const initialToastState = {
  open: false,
  message: "",
  type: "success",
};

const Contracts = () => {
  const [drawerState, setDrawerState] = useState({
    isOpen: false,
  });

  const [toast, setToast] = useState(initialToastState);

  const {
    data: contractsData,
    isLoading: areContractsLoading,
    refetch,
  } = useQuery("allContracts", getContracts);

  const contracts = React.useMemo(
    () => contractsData?.data ?? [],
    [contractsData]
  );

  const [editing, setEditing] = useState({
    state: false,
    contract: {},
  });

  const toggleDrawer = (isOpen) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerState({ isOpen });
    setEditing({
      state: false,
      contract: {},
    });
  };

  const handleEditRow = (contract) => {
    setDrawerState({ isOpen: true });
    setEditing({
      state: true,
      contract,
    });
  };

  const handleDeleteRow = async (contractId) => {
    if (window.confirm("Are you sure you want to delete this contract?")) {
      try {
        await deleteContract(contractId);
        setToast({
          type: "success",
          open: true,
          message: "Contract deleted successfully.",
        });

        refetch();
      } catch (err) {
        const toastMessage =
          err?.response?.data?.message ?? "Something went wrong";
        setToast({
          open: true,
          message: toastMessage,
          type: "danger",
        });
      }
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },

      {
        Header: "Start Date",
        accessor: "startDate",
        Cell: ({ value }) => value?.split("T")[0],
      },
      {
        Header: "End Date",
        accessor: "endDate",
        Cell: ({ value }) => value?.split("T")[0] || "N/A",
      },

      {
        Header: "Creation Date",
        accessor: "createdAt",
        Cell: ({ value }) => value?.split("T")[0],
      },

      {
        id: "status",
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        // Filter: ContractStatusFilter,
        Cell: ({ value }) => (
          <span
            className={`font-weight-bold fs-14 badge badge-${statusCssClasses[value]}`}
          >
            {value}
          </span>
        ),

        filter: "includes",
      },

      {
        Header: "Actions",
        accessor: (originalRow) => originalRow,
        disableSortBy: true,
        Cell: ({ value }) => (
          <div
            className="d-inline-flex justify-content-center align-items-center"
            title=""
          >
            <Link to={`/artistDashboard/contract/${value._id}`}>
              <div className="admin-release-details-link mr-2">Details</div>
            </Link>
            |
            <div
              className="admin-release-details-link mx-2"
              onClick={() => handleEditRow(value)}
            >
              Edit
            </div>
            |
            <span
              role="button"
              onClick={() => handleDeleteRow(value._id)}
              className="ml-2 cursor-pointer"
              title="Delete contract"
            >
              <img src={TrashIcon} alt="delete contract" />
            </span>
          </div>
        ),
      },
      {
        Header: " ",
        accessor: "_id",
      },
    ],
    []
  );

  const tableInstance = useTable(
    {
      columns,
      data: contracts,
      initialState: {
        pageIndex: 0,
        pageSize: INITIAL_PAGE_SIZE,
        hiddenColumns: ["_id"],
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const {
    state: { globalFilter, filters },
    setFilter,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = tableInstance;
  return (
    <main className="myReleases-overview">
      <Toast
        open={toast.open}
        onClose={() =>
          setToast((prevState) => ({ open: false, type: prevState.type }))
        }
        toastMessage={toast.message}
        toastType={toast.type}
      />
      <section className="myReleases-header">
        <div className="distributionButton" onClick={toggleDrawer(true)}>
          New Contract
        </div>
        <br />
        <div className="distributionGuidelinesNote">
          Contracts are used to pay royalties to the rightholders of your music
          releases.
        </div>
        <br />
        {/* decoration boxes */}
        <div className="dDecoration1">
          <div className="dd1a">+</div>
        </div>
        <div className="dShader"></div>
        <div className="dDecoration2">
          <div className="dd2Text">Genre</div>
          <div className="dd2badge1">future house</div>
          <div className="dd2badge2">techno</div>
          <div className="dd2badge3">hard style</div>
          <div className="dd2badge4"></div>
        </div>
        <div className="dDecoration3">
          <img src={VectorStar} alt="star" className="dd3star" />
          <img src={Group} alt="group" className="dd3group" />
        </div>
        <div className="dDecoration4">
          <div className="dd4Inner1">
            <img src={Sp} alt="Spotify" className="dd4InnerSpotify" />
          </div>
        </div>
      </section>

      {/* GRID AND LIST VIEW */}
      <div className="allowUserSelect">
        <main className="admin-releases mt-4" style={{ marginLeft: "0" }}>
          <div className="d-block mb-3" style={{ zIndex: 1 }}>
            <p className="font-weight-bold text-white mb-2">Filter by:</p>
            <div className="row pb-2 align-items-center justify-content-between">
              <div className="col-12 col-md">
                <div className="row">
                  <GlobalFilter
                    preGlobalFilteredRows={preGlobalFilteredRows}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                  />
                  <ContractStatusFilter
                    setFilter={setFilter}
                    filters={filters}
                  />
                </div>
              </div>
            </div>
          </div>

          <TableView
            tableInstance={tableInstance}
            loading={areContractsLoading}
          />
        </main>
      </div>

      <Drawer
        anchor={window.innerWidth < 768 ? "bottom" : "right"}
        open={drawerState.isOpen}
        onClose={toggleDrawer(false)}
        className="h-100"
      >
        <div
          className={`bg-dark overflow-auto vh-100 admin-release-drawer`}
          role="presentation"
        >
          <div
            onClick={toggleDrawer(false)}
            className=" mx-0 mb-4 d-flex justify-content-between align-items-center text-white px-3 py-4 contract-drawer-header"
          >
            <div>
              <span>{`${editing.state ? "Edit" : "Create"} Contract`}</span>
            </div>
            <div className="cursor-pointer">
              <FontAwesomeIcon
                icon={faTimes}
                style={{ width: "20px", height: "20px" }}
              />
            </div>
          </div>
          <ContractForm
            onUpdate={setDrawerState}
            onClose={toggleDrawer(false)}
            edit={editing.state}
            contract={editing.contract}
            refetch={refetch}
          />
        </div>
      </Drawer>
    </main>
  );
};

export default Contracts;
